import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import * as React from "react";
import { formatDate } from "src/util/Date.helper";

interface IScheduleInformationProps {
  expensePaymentDate: Date;
}

export const ScheduleInformation: React.FC<IScheduleInformationProps> = ({ expensePaymentDate }) => {
  return (
    <Tooltip title={`Pagamento agendado para: ${formatDate(expensePaymentDate)}`}>
      <FontAwesomeIcon style={{ marginLeft: "5px", marginBottom: "3px" }} size="lg" color="#0dd900" icon={faCalendarCheck} />
    </Tooltip>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/Scheduled/ScheduleInformation.tsx